/* eslint-disable import/prefer-default-export */
import axios from 'axios';

const column = '/system/member-column';

/** -------------栏目和标签api--------------- */
/**
 * 栏目保存
 * @param {*} option
 */
export function saveColumn(option) {
    return axios.post(column, option, { encode: true });
}

/**
 * 查询栏目
 * @return {*}
 */
export function getColumn() {
    return axios.get(column);
}

/**
 * 查询标签
 * @return {*}
 */
export function getTopic() {
    return axios.get('/human/member/topic', { encode: true });
}

/**
 * 标签保存
 * @param {*} option
 */
export function saveTopic(option) {
    return axios.post('/human/member/insert-topic', option, { encode: true });
}

/**
 * 查询标签类别
 * @return {*}
 */
export function getTopicType() {
    // '/system/topic-type/front'
    return axios.get('/system/topic-type/findTopicType', { params: { status: 1 } });
}

/**
 * 查询子标签
 * @param {*} option
 */
export function getTopicChild(option) {
    // '/system/topic/select'
    return axios.get('/system/topic/findTopic', { params: option });
}

/** --------------推荐,热榜, 相关推荐api--------------  */

/**
 * 推荐开关
 */
export function recommendSwitch() {
    return axios.get('/system/rule-config/recommend-switch');
}

/**
 * 调用达观接口前调用, 获取用户受众
 * @param {*} option
 */
export function loadAudiences() {
    return axios.get('/help-center/load-audiences');
}


/**
 * 个性化推荐
 * @param {*} option
 * 类别: businessType 1 课程 2 专题 3 直播 4 知识 5 竞赛 6 考试 7 调研 8 培训班 9 纷享
 */
export function perRecommend(option) {
    // , loading: true
    return axios.get('/zxy-log/recommend/personal', { params: option || {} });
}

/**
 * tab页-推荐: 内容列表数据
 * @param {*} option
 */
export function recommendedListApi(option) {
    return axios.get('/knowledge-operation/question/recommend-question', {
        params: {
            ...option,
            page: 2,
            pageSize: 10,
            orderType: 1
        }
    });
}

/**
 * tab页-推荐: 个性化推荐
 * @param {*} option
 */
export function recommendPersonalApi(option) {
    return axios.get('/zxy-log/recommend/personal', { params: option || {} });
}

/**
 * tab页-推荐: 达观推荐内容列表
 * @param {*} option
 */
export function daGuanRecommendedListApi(option) {
    return axios.get('/knowledge-operation/question/recommend', { params: option });
}

/**
 * 关注
 * @param {*} option
 */
export function attention(option) {
    // , loading: true
    return axios.get('/ask-bar/trend/scroll/trends-mine-expert', { params: option });
}

/**
 * 热门推荐
 * @params {*} option
 */

export function hotRecommend(option) {
    // , loading: true
    return axios.get('/zxy-log/recommend/hot', { params: option || {} });
}

/**
 * 置顶内容
 * @params {*} option
 */
export function topRecommend() {
    return axios.get('/system/top-content/find-list');
}

/**
 * 是否是我关注的专家
 * @param {*} option
 */
export function attentionExperts(option) {
    return axios.get('/ask-bar/attention/expert-ids', { params: option });
}

/**
 * 关注专家
 * @param {*} option
 */
export function focusExpert(option) {
    return axios.post('ask-bar/attention', option, { encode: true });
}

/**
 * 取消关注
 * @param {*} option
 */
export function cancelExpert(id) {
    return axios.delete(`ask-bar/attention/${id}`);
}

/**
 * 取关注id
 * @param {*} option
 */
export function getAttentionId(id) {
    return axios.get(`ask-bar/expert/${id}`);
}

/** ---------------根据不同的业务类型查询资源数据------------------ */

/**
 * 课程/专题
 * @param {*} option
 */
export function courseData(option) {
    return axios.get('/course-study/course-info/front/find-by-ids', { params: option });
}

/**
 * 知识
 * @param {*} option
 */
export function knowledgeData(option) {
    return axios.get('/course-study/knowledge/ids', { params: option });
}

/**
 * 直播
 * @param {*} option
 */
export function genseeData(option) {
    return axios.get('/course-study/gensee/front/find-by-ids', { params: option });
}

/**
 * 纷享
 * @param {*} option
 */
export function askData(option) {
    return axios.get('/ask-bar/question/find-by-ids-recommend', { params: option });
}

/**
 * 考试
 * @param {*} option
 */
export function examData(option) {
    return axios.get('/exam/exam/front/find-by-ids-old', { params: option });
}

/**
 * 调研
 * @param {*} option
 */
export function researchData(option) {
    return axios.get('/exam/research-activity/front/find-by-ids', { params: option });
}

/**
 * 培训
 * @param {*} option
 */
export function trainData(option) {
    return axios.get('/training/student/class-info/front/find-by-ids', { params: option });
}

/**
 * 外部活动
 * @param {*} option
 */
export function externalActivity(option) {
    return axios.get('/training/external-activity/list', { params: option });
}

/**
 * 赛事
 * @param {*} option
 */
export function competitionData(option) {
    return axios.get('/microclass/competition/find-by-ids', { params: option });
}

/**
 * 学习包
 * @param {*} option
 */
export function studyBags(option) {
    return axios.get('/course-study/study-push/front/find-by-ids', { params: option });
}


/**
 * 评论数
 * @param {*} option
 */
export function commentData(option) {
    return axios.get('/system/comment/count-by-business-ids', { params: option });
}

